import React from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import { useTranslation } from '../../hooks/useTranslation';
import TextField, { TextFieldProps } from '../text-field/TextField';

interface TextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

const TextMaskCustom = (textMaskProps: TextMaskCustomProps | any) => {
  const { inputRef, inputProps, ...other } = textMaskProps;
  const numberMask = createNumberMask({
    prefix: '',
    integerLimit: 10,
    includeThousandsSeparator: false,
    allowLeadingZeroes: true,
  });

  return (
    <MaskedInput
      data-testid={'accountField'}
      {...other}
      name={textMaskProps.name || 'accountNumber'}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={numberMask}
      guide={false}
      showMask
    />
  );
};

const AccountTextField = React.forwardRef(
  (props: TextFieldProps | any, ref?: React.Ref<HTMLInputElement>) => {
    const { t } = useTranslation();
    const label = props.label || t('ACCOUNT');

    return (
      <TextField
        label={label}
        ref={ref}
        margin={'normal'}
        {...props}
        name={props.name || 'accountNumber'}
        helperText={props.helperText || props.error}
        defaultValue={props.defaultValue || null}
        style={props.style || { width: '100%' }}
        InputProps={{
          ...props.InputProps,
          inputComponent: TextMaskCustom,
        }}
        inputProps={{
          ...props.inputProps,
          maxLength: 10,
          minLength: 10,
          type: 'tel', // Use tel instead of number to avoid browser behaviour
        }}
        variant={props.variant || null}
      />
    );
  },
);
export default AccountTextField;
